import { getOCPSErrorMessage } from 'mini-ocps-policy-store/lib/utils/ocpsStoreUtils';
import { OCPSDataStorePolicyValue } from 'mini-ocps-policy-store/lib/store/schema/OCPSDataStoreType';
import { USER_OCPS_FEEDBACK_ENABLED } from 'mini-ocps-policy-store/lib/utils/constants';
import {
    doesOCPSDataStoreHasError,
    fetchPoliciesAndSetStore,
    getPolicyValue,
} from 'mini-ocps-policy-store';

export const isSendFeedbackPolicyEnabledForBusinessUser = async (): Promise<boolean> => {
    await fetchPoliciesAndSetStore();
    if (doesOCPSDataStoreHasError()) {
        const errorMessage = getOCPSErrorMessage();
        throw new Error(`launchOCVFeedback: OCPSPolicy fetch failed: ${errorMessage}`);
    }
    const isSendFeedbackEnabled =
        getPolicyValue(USER_OCPS_FEEDBACK_ENABLED) === OCPSDataStorePolicyValue.Enabled;
    return isSendFeedbackEnabled;
};
